import { render, staticRenderFns } from "./folder-breadcrumb.vue?vue&type=template&id=04f20578&scoped=true&"
import script from "./folder-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./folder-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./folder-breadcrumb.vue?vue&type=style&index=0&id=04f20578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f20578",
  null
  
)

export default component.exports